<template>
  <div class="pc-address inner-box">
    <bread :backTitle="$t('address.nav')"></bread>
    <!-- 地址信息 -->
    <adr-info></adr-info>
    <!-- 交易记录、token记录 -->
    <div class="adr-tx-record table-shadow">
      <div class="head flex-between">
        <div class="tab-group">
          <span :class="{ 'active-tab': tab === 0 }" @click="tab = 0">{{
            $t("address.record")
          }}</span>
          <span :class="{ 'active-tab': tab === 1 }" @click="tab = 1">{{
            $t("address.tokenRecord")
          }}</span>
        </div>
        <div class="flex-right">
          <span style="margin-right: 10px;">value >= 1</span>
          <el-switch v-model="filterValue" />
        </div>
      </div>
      <div class="total flex-between">
        <span>
          {{ $t("address.txTotal", [showTotal]) }}
          <span v-if="showTotal > 10000">（{{ $t("address.last", [pages.total]) }}）</span>
        </span>
        <el-select v-model="txType" placeholder="please choose trade's type" size="small" class="tx-select"
          @change="filterTrade">
          <el-option class="trade-option" v-for="item in options" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </div>
      <!-- 表格部分 -->
      <el-table :data="Trades" stripe style="width: 100%" class="data-table" v-loading="loading"
        element-loading-text="Loading..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.8)">
        <el-table-column :label="$t('trade.hash')" width="190">
          <template slot-scope="item">
            <router-link :to="`/tx/${item.row.hash}`" class="light flex-left">
              <i class="iconfont err-ico" :class="{
                'iconjinggao-chucuo':
                  item.row.success === false && item.row.is_para === false,
              }"></i>
              {{ item.row.hash | filterHash }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('trade.sender')" width="190">
          <template slot-scope="item">
            <router-link :to="`/address/${item.row.from}`" :class="{
              light: item.row.from !== addr,
              base: item.row.from === addr,
            }">{{ item.row.from | filterHash }}</router-link>
          </template>
        </el-table-column>
        <el-table-column width="55">
          <template slot-scope="item">
            <i class="iconfont iconqianjin"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('trade.receiver')" width="200">
          <template slot-scope="item">
            <router-link :to="`/address/${item.row.to}`" :class="{
              light: item.row.to !== addr,
              base: item.row.to === addr,
            }">{{ item.row.to | filterHash }}</router-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('trade.num')" min-width="150">
          <template slot-scope="item">{{ item.row | TradeValue }}</template>
        </el-table-column>
        <el-table-column :label="$t('trade.fee')" width="110">
          <template slot-scope="item">{{ item.row.fee | filterFee }}</template>
        </el-table-column>
        <el-table-column :label="$t('trade.func')" width="110">
          <template slot-scope="item">{{
            item.row.action_name === "unknown" ? "none" : item.row.action_name
          }}</template>
        </el-table-column>
        <el-table-column :label="$t('trade.time')" width="170">
          <template slot-scope="item">{{
            item.row.block_time | formatTime
          }}</template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 底部分页 -->
    <div class="bottom-page flex-right" v-if="Trades.length !== 0">
      <page-container @pageChange="pageChange" @sizeChange="sizeChange" :currentPage="pages.number"
        :pageSize="pages.size" :total="pages.total"></page-container>
    </div>
  </div>
</template>

<script>
import AdrInfo from "./AdrInfos";
import Bread from "@/components/computer/Breadcrumb.vue";
import PageContainer from "@/components/computer/PageContainer.vue";
import addrBase from "@/mixins/Address/addressRecord.js";
export default {
  mixins: [addrBase],
  components: {
    Bread,
    AdrInfo,
    PageContainer,
  },
};
</script>

<style lang="scss">
.pc-address {
  .adr-tx-record {
    margin-top: 30px;
    background: $white;
    border-radius: 2px;
    border: 1px solid rgba(235, 239, 241, 1);

    .iconfont {
      font-size: 25px;
      color: #9aaab9;
    }

    .err-ico {
      color: #e45359;
      font-size: 12px;
      width: 13px;
      margin-right: 5px;
      display: inline-flex;
    }

    .iconjin {
      color: #6ca89b;
    }

    .iconchu {
      color: #eb827c;
    }

    .head {
      height: 78px;
      padding: 0 25px;
      border-bottom: 1px solid #ececec;

      span {
        display: inline-block;
        height: 100%;
        width: fit-content;
        line-height: 78px;
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        font-weight: 500;
        text-align: center;
        color: $black;
        cursor: pointer;
        transition: 0.5s;
      }

      .tab-group span:last-child {
        margin-left: 60px;
        // width: 120px;
      }

      .active-tab {
        color: $blue;
        border-bottom: 2px solid $blue;
      }
    }

    .total {
      height: 90px;
      padding: 0 30px;
      background: #f9fafc;
      border-bottom: 1px solid #ececec;

      span {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: $font_grey;
      }

      .tx-select {
        width: 310px;

        input {
          border-radius: 20px;
        }
      }
    }
  }

  .bottom-page {
    margin-top: 23px;
  }

  .el-table th:nth-of-type(1) .cell {
    padding-left: 30px;
  }

  .el-loading-mask {
    top: 60px;
  }
}

.trade-option {
  color: $black;
  transition: 0.3s;
}

.trade-option.hover {
  color: #dd9e2d;
}
</style>
